<template>
    <div class="row justify-end items-center">

        <div style="min-width: 175px; max-width: 175px;" :class="{'full-width' : fullWidth}">
            <q-select v-model="selectedCurrency"
                      autocomplete="off"
                      @input="syncCurrency"
                      :loading="getCurrenciesPending"
                      :options="currencies"
                      :readonly="isLoggedIn"
                      :bg-color="!isLoggedIn ? 'white' : ''"
                      option-value="key"
                      option-label="value"
                      label="Currency"
                      dense options-dense rounded
                      style="visibility: hidden;">
                <template v-slot:append>
                    <div class="flag-hover-wrapper">
                        <img :src="getCurrencyFlag" class="flag-icon" />
                        <span class="currency-txt-label">Currency:</span>
                        <span class="currency-label">{{ selectedCurrency?.value }}</span>
                    </div>
                </template>
                <q-tooltip v-if="isLoggedIn">
                    Currency has been set to match your account profile location settings
                </q-tooltip>
            </q-select>
        </div>
    </div>
</template>
<script>
    import { mapState } from 'vuex'

    export default {
        name: 'currency-select',
        props: {
            fullWidth: Boolean,
        },
        data() {
            return {
                currencyFlags: {
                    usa: require('@/assets/img/flags/usa.png'),
                    canada: require('@/assets/img/flags/canada.png')
                },
                currencies: [],
                selectedCurrency: null,
            }
        },
        methods: {
            getCurrencies() {
                if (!!this.currencies.length) {
                    this.selectedCurrency = this.currencies?.find(c => c.key == this.cart.currency)
                    return
                }
                this.$store.dispatch('getCurrencies').then(() => {
                    if (this.getCurrenciesData && typeof this.getCurrenciesData !== 'undefined') {
                        this.currencies = this.getCurrenciesData
                        this.selectedCurrency = this.currencies?.find(c => c.key == this.cart.currency)
                    }
                })
            },
            syncCurrency() {
                this.$store.dispatch('updateCurrency', this.selectedCurrency.key)
            }
        },
        computed: {
            ...mapState([
                'getCurrenciesData',
                'getCurrenciesPending',

                'getAccountInfoData',
                'getAccountInfoPending',

                'updateCartCustomerData',
                'updateCartCustomerPending',
            ]),
            cart() { return this.$store.getters.cart },
            getCurrencyFlag() {
                if (this.selectedCurrency) {
                    if (this.selectedCurrency.value == 'USD') {
                        return this.currencyFlags.usa
                    }
                    else if (this.selectedCurrency.value == 'CAD') {
                        return this.currencyFlags.canada
                    }
                }
                return ''
            },
            isLoggedIn() { return this.$store.getters.isLoggedIn },
        },
        created() {
            this.getCurrencies()
            if (this.isLoggedIn) {
                var user = JSON.parse(localStorage.getItem('user')) || null

                if (user) {
                    this.$store.dispatch('getAccountInfoByEmail', user.username).then(() => {
                        this.$store.dispatch('updateCartCustomer', this.getAccountInfoData)
                    })
                }
            }
        },
        watch: {
            'cart.currency'(newVal) {
                if (!!this.currencies.length)
                    this.selectedCurrency = this.currencies?.find(c => c.key == newVal)
            }
        }
    }
</script>
<style scoped>
    ::v-deep .q-field--dense .q-field__append + .q-field__append {
        display: none;
    }

    .flag-hover-wrapper {
        display: flex;
        visibility: visible;
        align-items: center;
        background-color: var(--q-color-primary) !important;
        padding: 13px 13px;
        border-radius: 30px;
        transition: all 0.3s ease;
        overflow: hidden;
        max-width: 56px;
    }

        .flag-hover-wrapper:hover {
            max-width: 200px;
            background-color: var(--q-color-primary) !important;
        }

    .flag-icon {
        width: 30px;
        height: 30px;
        transition: all 0.3s ease;
    }

    .currency-txt-label {
        font-size: 14px;
        color: var(--q-color-info);
        margin-left: 13px;
    }

    .currency-label {
        color: white;
        font-weight: 500;
        font-size: 14px;
        margin: 0 5px 0 10px;
        white-space: nowrap;
        opacity: 0;
        transition: opacity 0.3s ease;
    }

    .flag-hover-wrapper:hover .currency-label {
        opacity: 1;
    }
</style>
